import { render } from "./tenant-update.vue?vue&type=template&id=64129bea"
import script from "./tenant-update.vue?vue&type=script&lang=js"
export * from "./tenant-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__